/**
 * Status rule for checking online/offline status of widgets.
 */
export default class StatusRule {
    constructor({
        u = 0,
        d = [],
        c = '',
        coverageType = 0,
        coverageHours = null, // @prop {Object|null} day prop = hours range array
        fallbackSeconds = 0
    }) {
        this.u = u;
        this.d = d;
        this.c = c;
        this.coverageType = coverageType;
        this.coverageHours = coverageHours;
        this.fallbackSeconds = fallbackSeconds;
    }

    /**
     * Think we don't need the extra coop coverage options for this.
     * @returns {Object}
     */
    toJSON() {
        const obj = {
            u: this.u,
            d: this.d,
            c: this.c,
            fallbackSeconds: this.fallbackSeconds
        };
        return obj;
    }
}
